import { useState, useEffect } from "react";
import { Container,Row,Col,Table, Button} from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";

function QuotationTable({ data, setDataItems}) {
  const [dataRows, setDataRows] = useState();
  const [total, setTotal] = useState(0);
  const [total_discont, setTotal_discount] = useState(0);

  const style= {
    textCenter:{textAlign:"center"},
    textRight:{textAlign:"right"},
  }

  useEffect(() => {
    let sum = 0;
    let sum_discount=0;

    const z = data.map((v, i) => {
    let amount = v.qty * v.ppu-v.discount;
    let discountprice = v.discount*1;
    if (amount<0){
      amount = 0;
    }
    if(discountprice<0||NaN){
      discountprice=0;
    } 
    
    sum+=amount;
    sum_discount+=discountprice;
    return (
      <tr key={i}>
        <td className={style.textCenter}>
          <FaTrashAlt onClick={() => deleteItem(i)} />
        </td>
        <td className={style.textCenter}>{v.qty}</td>
        <td>{v.item}</td>
        <td className={style.textCenter}>{formatNumber(v.ppu)}</td>
        <td className={style.textCenter}>{formatNumber(discountprice)}</td>
        <td className={style.textRight}>{formatNumber(amount)}</td>
      </tr>
      );
    });
    setDataRows(z);
    setTotal(sum);
    setTotal_discount(sum_discount);
  }, [data]);
  

  const deleteItem = (i) => {
    data.splice(i,1)
    setDataItems([...data])
  };

  const clearTable = () => {
    setDataItems([]);
    setDataRows([]);
  };

  const formatNumber = (x) => {
    x = Number.parseFloat(x)
    return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Container>
      <Row>
        <Col>
            <h1>Quotation</h1>
        </Col>
        <Col style={style.textRight}>
            <Button onClick={clearTable} variant="dark">Clear</Button>
        </Col>
      </Row>
      <Table striped bordered hover>
        <thead>
          <tr>
          <th style={{ width: "20px" }}>&nbsp;</th>
            <th className={style.textCenter}>Qty</th>
            <th className={style.textCenter}>Item</th>
            <th className={style.textCenter}>Price/Unit</th>
            <th className={style.textCenter}>Discount</th>
            <th className={style.textCenter}>Amount</th>
          </tr>
        </thead>
        <tbody>{dataRows}</tbody>
        <tfoot>
          <tr>
            <td colSpan={4} className={style.textRight}>
              Total
            </td>
            <td className={style.textRight}>
              {formatNumber(total_discont)}
            </td>
            <td className={style.textRight}>
              {formatNumber(total)}
            </td>
          </tr>
        </tfoot>
      </Table>
    </Container>
  );
}

export default QuotationTable;
